// import appsIcon from "@assets/images/menu-apps-icon.svg";
import catalogIcon from "@assets/images/menu-catalog-icon.svg";
import customerIcon from "@assets/images/menu-customers-icon.svg";
import discountsIcon from "@assets/images/menu-discounts-icon.svg";
import homeIcon from "@assets/images/menu-home-icon.svg";
import instagram from "@assets/images/menu-instagram-icon.svg";
import ordersIcon from "@assets/images/menu-orders-icon.svg";
import pageManageIcon from "@assets/images/menu-pageManage-icon.svg";
// import shipmentIcon from "@assets/images/menu-shipment-icon.svg";
import translationIcon from "@assets/images/menu-translation-icon.svg";
import { coverListUrl } from "@saleor/cover/urls";
import { erpStatusNoteSection } from "@saleor/erpstatusnote/urls";
import { commentListUrl } from "@saleor/inscomment/urls";
import { commonMessages, sectionNames } from "@saleor/intl";
import { pageEventSection, pageManageSection } from "@saleor/pageManage/urls";
import { IntlShape } from "react-intl";

// import { appsListPath } from "../../apps/urls";
import { categoryListUrl } from "../../categories/urls";
import { collectionListUrl } from "../../collections/urls";
import { customerListUrl } from "../../customers/urls";
import { saleListUrl, voucherListUrl } from "../../discounts/urls";
import { inslabelListUrl } from "../../inslabel/urls";
import { instagramListUrl } from "../../instagram/urls";
// import { orderDraftListUrl, orderListUrl } from "../../orders/urls";
import { orderListUrl } from "../../orders/urls";
import { productListUrl } from "../../products/urls";
import { shipmentListUrl } from "../../shipment/urls";
import { languageListUrl } from "../../translations/urls";
import { PermissionEnum } from "../../types/globalTypes";

export interface IMenuItem {
  ariaLabel: string;
  children?: IMenuItem[];
  icon?: any;
  label: string;
  permission?: PermissionEnum;
  testingContextId: string;
  url?: string;
}

function createMenuStructure(intl: IntlShape): IMenuItem[] {
  return [
    {
      ariaLabel: "home",
      icon: homeIcon,
      label: intl.formatMessage(sectionNames.home),
      testingContextId: "home",
      url: "/"
    },
    {
      ariaLabel: "pageManage",
      children: [
        {
          ariaLabel: "visualEditing",
          label: intl.formatMessage(sectionNames.visualEditing),
          testingContextId: "visualEditing",
          url: pageManageSection
        },
        {
          ariaLabel: "pageEvent",
          label: intl.formatMessage(sectionNames.pageEvent),
          testingContextId: "pageEvent",
          url: pageEventSection
        }
      ],
      icon: pageManageIcon,
      label: intl.formatMessage(sectionNames.pageManage),
      permission: PermissionEnum.MANAGE_PAGES,
      testingContextId: "pageManage"
    },
    {
      ariaLabel: "catalogue",
      children: [
        {
          ariaLabel: "products",
          label: intl.formatMessage(sectionNames.products),
          testingContextId: "products",
          url: productListUrl()
        },
        {
          ariaLabel: "categories",
          label: intl.formatMessage(sectionNames.categories),
          testingContextId: "categories",
          url: categoryListUrl()
        },
        {
          ariaLabel: "recommendationgroups",
          label: intl.formatMessage(sectionNames.recommendationgroups),
          testingContextId: "recommendationgroups",
          url: collectionListUrl()
        },
        {
          ariaLabel: "Product Detail Plugins",
          label: intl.formatMessage(sectionNames.cover),
          testingContextId: "cover",
          url: coverListUrl()
        }
      ],
      icon: catalogIcon,
      label: intl.formatMessage(commonMessages.catalog),
      permission: PermissionEnum.MANAGE_PRODUCTS,
      testingContextId: "catalogue"
    },
    {
      ariaLabel: "orders",
      children: [
        {
          ariaLabel: "orders",
          label: intl.formatMessage(sectionNames.orders),
          permission: PermissionEnum.MANAGE_ORDERS,
          testingContextId: "orders",
          url: orderListUrl()
        },
        // {
        //   ariaLabel: "order drafts",
        //   label: intl.formatMessage(commonMessages.drafts),
        //   permission: PermissionEnum.MANAGE_ORDERS,
        //   testingContextId: "order drafts",
        //   url: orderDraftListUrl()
        // },
        {
          ariaLabel: "shipment",
          label: intl.formatMessage(sectionNames.shipment),
          permission: PermissionEnum.MANAGE_SHIPMENT,
          testingContextId: "shipment",
          url: shipmentListUrl()
        },
        {
          ariaLabel: "statusnote",
          label: intl.formatMessage(sectionNames.erpstatusnote),
          permission: PermissionEnum.MANAGE_ORDERS,
          testingContextId: "statusnote",
          url: erpStatusNoteSection
        }
      ],
      icon: ordersIcon,
      label: intl.formatMessage(sectionNames.orders),
      permission: PermissionEnum.MANAGE_ORDERS,
      testingContextId: "orders"
    },
    {
      ariaLabel: "instagram",
      children: [
        {
          ariaLabel: "instagram",
          label: intl.formatMessage(sectionNames.instagramList),
          permission: PermissionEnum.MANAGE_INSTAGRAM,
          testingContextId: "instagram",
          url: instagramListUrl()
        },
        {
          ariaLabel: "label",
          label: intl.formatMessage(sectionNames.label),
          permission: PermissionEnum.MANAGE_INSTAGRAM_LABEL,
          testingContextId: "inslabel",
          url: inslabelListUrl()
        },
        {
          ariaLabel: "comment",
          label: intl.formatMessage(sectionNames.comment),
          permission: PermissionEnum.MANAGE_INSTAGRAM,
          testingContextId: "inscomment",
          url: commentListUrl()
        }
      ],
      icon: instagram,
      label: intl.formatMessage(sectionNames.instagram),
      permission: PermissionEnum.MANAGE_INSTAGRAM,
      testingContextId: "instagram"
    },
    {
      ariaLabel: "customers",
      icon: customerIcon,
      label: intl.formatMessage(sectionNames.customers),
      permission: PermissionEnum.MANAGE_USERS,
      testingContextId: "customers",
      url: customerListUrl()
    },
    // {
    //   ariaLabel: "shipment",
    //   icon: shipmentIcon,
    //   label: intl.formatMessage(sectionNames.shipment),
    //   permission: PermissionEnum.MANAGE_USERS,
    //   testingContextId: "shipment",
    //   url: shipmentListUrl()
    // },
    {
      ariaLabel: "discounts",
      children: [
        {
          ariaLabel: "sales",
          label: intl.formatMessage(sectionNames.sales),
          testingContextId: "sales",
          url: saleListUrl()
        },
        {
          ariaLabel: "vouchers",
          label: intl.formatMessage(sectionNames.vouchers),
          testingContextId: "vouchers",
          url: voucherListUrl()
        }
      ],
      icon: discountsIcon,
      label: intl.formatMessage(commonMessages.discounts),
      permission: PermissionEnum.MANAGE_SALES,
      testingContextId: "discounts"
    },
    // {
    //   ariaLabel: "apps",
    //   icon: appsIcon,
    //   label: intl.formatMessage(sectionNames.apps),
    //   permission: PermissionEnum.MANAGE_APPS,
    //   testingContextId: "apps",
    //   url: appsListPath
    // },

    {
      ariaLabel: "translations",
      icon: translationIcon,
      label: intl.formatMessage(sectionNames.translations),
      permission: PermissionEnum.MANAGE_TRANSLATIONS,
      testingContextId: "translations",
      url: languageListUrl
    }
  ];
}

export default createMenuStructure;
